export const parseProject = (response) => {
  const { projects } = response.data;
  if (projects.length > 0) {
    return {
      project: projects[0],
    };
  }
};
